import React from "react";

import Layout from "../../components/Layout";

import {
  Container,
  Title,
} from './styles';

const Break = () => {
  return (
    <Layout>
      <Container>
        <Title>SH+ Assistant unavailable during exam day</Title>
      </Container>
    </Layout>
  );
};

export default Break;
